import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Download } from "lucide-react";

export default function AdminSubscribers() {
  const [subs, setSubs] = useState([]);
  const load = () => api.get("/newsletter/subscribers").then(({ data }) => setSubs(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    try {
      await api.delete(`/newsletter/subscribers/${id}`);
      toast.success("Removed.");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Delete failed");
    }
  };

  const exportCsv = () => {
    const rows = [["email", "name", "created_at"], ...subs.map((s) => [s.email, s.name || "", s.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers-page">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-8">
        <div>
          <h1 className="font-fredoka text-4xl" style={{ color: "#2D3055" }}>Newsletter</h1>
          <p className="mt-1" style={{ color: "#4A4E6D" }}>{subs.length} kind soul{subs.length !== 1 && "s"} on your list.</p>
        </div>
        <button onClick={exportCsv} className="btn-ghost-warm" data-testid="export-csv-btn"><Download size={16} /> Export CSV</button>
      </div>

      <div className="warm-card overflow-hidden">
        <table className="w-full text-sm font-nunito">
          <thead style={{ background: "#E7EEFF" }}>
            <tr className="text-left">
              <th className="px-5 py-3 font-fredoka" style={{ color: "#2D3055" }}>Email</th>
              <th className="px-5 py-3 font-fredoka" style={{ color: "#2D3055" }}>Name</th>
              <th className="px-5 py-3 font-fredoka" style={{ color: "#2D3055" }}>Subscribed</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-t" style={{ borderColor: "#C7B5FF" }} data-testid={`sub-row-${s.id}`}>
                <td className="px-5 py-3" style={{ color: "#2D3055" }}>{s.email}</td>
                <td className="px-5 py-3" style={{ color: "#4A4E6D" }}>{s.name || "—"}</td>
                <td className="px-5 py-3 text-xs" style={{ color: "#7E82A1" }}>
                  {new Date(s.created_at).toLocaleDateString()}
                </td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => remove(s.id)} className="text-xs inline-flex items-center gap-1"
                    style={{ color: "#c1554b" }} data-testid={`delete-sub-${s.id}`}>
                    <Trash2 size={14} /> Remove
                  </button>
                </td>
              </tr>
            ))}
            {subs.length === 0 && (
              <tr><td colSpan={4} className="px-5 py-10 text-center" style={{ color: "#7E82A1" }}>No subscribers yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
